import { Component } from '@angular/core';
import { NavParams } from 'ionic-angular';

export interface SearchableItem {
    id: any,
    text: string,
}

type DoneFunction = (result: any) => any;
type QueryFunction = (query: string) => any;

@Component({
    selector: 'page-search',
    templateUrl: 'search.html',
})
export class SearchPage {

    filteredItems: SearchableItem[];
    message: string = 'Enter some text to search';
    title: string = 'Search';
    placeholder: string = 'Search';
    private onDone: DoneFunction;
    private onQuery: QueryFunction;
    private items: SearchableItem[];
    private item: SearchableItem;
    private query: string = '';


    constructor(
        private navParams: NavParams,
    ) {
        let title = this.navParams.get('title');
        let message = this.navParams.get('message');
        let placeholder = this.navParams.get('placeholder');

        if (title) this.title = title;
        if (message) this.message = message;
        if (placeholder) this.placeholder = placeholder;

        this.onDone = this.navParams.get('done');
        this.onQuery = this.navParams.get('query');
        this.items = this.navParams.get('items');
        this.item = this.navParams.get('item');

    }

    ngAfterViewInit() {
        this.resetFiltered();
    }

    chooseItem(item: SearchableItem) {
        this.item = item;
        this.onDone(item);
    }

    queryChange() {
        if (this.query.length < 1)
            return this.resetFiltered();

        let query: string = this.query;
        let queryCapped = query.charAt(0).toUpperCase() + query.slice(1);

        this.filteredItems = [];

        for (let item of this.items) {
            let text: string = item.text;
            if (text.search(queryCapped) > -1) this.filteredItems.push(item);
        }
        this.onQuery(this.query);
    }

    resetFiltered() {
        this.filteredItems = [];
        for (let item of this.items) {
            this.filteredItems.push(item);
        }
    }

    isSelected(item: SearchableItem): boolean {
        if (this.item === undefined) return false;
        return this.item.id === item.id;
    }

}



// WEBPACK FOOTER //
// ./src/pages/search/search.ts